export const convertBoolToYesOrNo = (val) => {
  return val ? 'Yes' : 'No'
}
